import { FormikErrors } from 'formik'
import { ChangeEvent } from 'react'
import { CreateProductValues } from '../../redux-toolkits/products/products.type'
import { HeaderSubheader } from '../typography/HeaderSubheader'

import { removeElementAtIndex } from '../../helpers'
import { ImageUploadButton } from '../button/imageUploadButton'
import { ImageBanner } from '../images/imageBanner'

export const ManageProductImages = ({
  values,
  setFieldValue,
  handleFileChange,
  typeTitle,
}: {
  values: CreateProductValues
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean,
  ) => Promise<void> | Promise<FormikErrors<CreateProductValues>>
  handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void
  typeTitle: string
}) => {
  return (
    <div className="flex flex-col gap-6 pb-10 border-b border-divider-gray">
      <HeaderSubheader
        title={`${typeTitle} Images`}
        text={`Upload ${typeTitle}  images`}
      />

      <div
        className="
        flex flex-row
        gap-6
        overflow-x-scroll
        "
      >
        {values.images.map((imageUrl, idx) => {
          const key = `productImage-${idx}`
          return (
            <ImageBanner
              key={key}
              className="!h-[140px] !w-[140px]"
              imageUrl={imageUrl}
              onDelete={() => {
                const imageList: string[] = JSON.parse(
                  JSON.stringify(values.images ?? []),
                )
                setFieldValue('images', removeElementAtIndex(imageList, idx))
              }}
            />
          )
        })}
        {values.images.length < 3 && (
          <ImageUploadButton
            showText
            handleChange={handleFileChange}
            className="!relative !rounded-lg size-[140px] !m-0 !top-0 !right-0"
            icon="pic-icon"
          />
        )}
      </div>
    </div>
  )
}
